import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEdit, faTrashAlt, faSpinner } from '@fortawesome/free-solid-svg-icons';
import './ActionButtons.css';

/**
 * Reusable ActionButtons component that matches the exact "old stack" design.
 * 
 * @param {Object} props
 * @param {Function} props.onView - Function to call on View click
 * @param {Function} props.onEdit - Function to call on Edit click
 * @param {Function} props.onDelete - Function to call on Delete click
 * @param {boolean} props.isDeleting - Whether the delete action is in progress
 * @param {boolean} props.hideView - (Optional) hide the view button
 * @param {boolean} props.hideEdit - (Optional) hide the edit button
 * @param {boolean} props.hideDelete - (Optional) hide the delete button
 */
const ActionButtons = ({
  onView,
  onEdit,
  onDelete,
  isDeleting = false,
  hideView = false,
  hideEdit = false,
  hideDelete = false,
  extraButtons = null
}) => {
  return (
    <div className="res-action-buttons-container">
      {!hideView && onView && (
        <button
          type="button"
          className="res-action-btn res-view-btn"
          onClick={onView}
          title="View"
        >
          <FontAwesomeIcon icon={faEye} />
        </button>
      )}

      {!hideEdit && onEdit && (
        <button
          type="button"
          className="res-action-btn res-edit-btn"
          onClick={onEdit}
          title="Edit"
        >
          <FontAwesomeIcon icon={faEdit} />
        </button>
      )}

      {!hideDelete && onDelete && (
        <button
          type="button"
          className="res-action-btn res-delete-btn"
          onClick={onDelete}
          title="Delete"
          disabled={isDeleting}
        >
          {isDeleting ? (
            <FontAwesomeIcon icon={faSpinner} spin />
          ) : (
            <FontAwesomeIcon icon={faTrashAlt} />
          )}
        </button>
      )}

      {typeof extraButtons === 'function' ? extraButtons() : extraButtons}
    </div>
  );
};

export default ActionButtons;
